import { MODEL_TYPE } from '@constants'

import { ColumnForm } from '../hooks/useInputs'

type GetDefaultValueType = {
  type?: MODEL_TYPE
}

export const getDefaultValue = (props: GetDefaultValueType): ColumnForm => {
  return {
    code: '',
    bindType: null,
    title: '',
    value: null,
    objectValue: null,
    actions: [],
    valueType: null,
    columnToSort: null,
    disableEditable: false,
    dropDownListCode: null,
    dropDownWindowCode: null,
    dropDownListFilters: [],
    dropDownWindowFilters: [],
    preFillSourceObject: null,
    preFillLink: [],
    preFillFilterObject: null,
    preFillFilterName: [],
    pinnedColumn: null,
    useParameters: false,
    enumDescription: true,
    useDisplayRule: false,
    asCheckbox: false,
    asDuration: false,
  }
}
